import {memo} from 'react';

import styled, {css} from 'styled-components';

import {body10Bold, body12Bold} from '~/shared/theme/typography';

import {RESTRICTION_AGE} from '../consts/restaurantConsts';
import {FlexCenter} from '../theme/FlexLayout';
import {flipOnLTR} from '../theme/flipOnLTR';

export type AgeRestrictionBadgeVariant = 'small' | 'regular';

const variantStyles = {
  small: css`
    width: 22px;
    height: 14px;
  `,
  regular: css`
    width: 29px;
    height: 18px;
  `,
};

const variantTextStyles = {
  small: css`
    ${body10Bold}
  `,
  regular: css`
    ${body12Bold}
  `,
};

const AgeRestrictionBadgeView = styled(FlexCenter)<{$variant: AgeRestrictionBadgeVariant; borderRadius: number}>`
  background-color: ${({theme}) => theme.colors.actionBlack};
  padding: 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({borderRadius}) => borderRadius}px;
  ${({$variant}) => variantStyles[$variant]}
`;

const AgeRestrictionText = styled.p<{$variant: AgeRestrictionBadgeVariant}>`
  color: ${({theme}) => theme.colors.primaryText};
  text-align: center;
  direction: ltr;
  line-height: 1;
  ${({$variant}) => variantTextStyles[$variant]}
`;

const BadgeContainer = styled(FlexCenter)`
  ${flipOnLTR`
      margin-right: 8px;
  `}
`;
interface AgeRestrictionBadgeProps {
  className?: string;
  variant?: AgeRestrictionBadgeVariant;
  borderRadius?: number;
}

const AgeRestrictionBadge = ({className, variant = 'regular', borderRadius = 4}: AgeRestrictionBadgeProps) => {
  const ageRestrictedText = `+${RESTRICTION_AGE}`;

  return (
    <BadgeContainer className={className} data-test-id="ageRestrictionBadge">
      <AgeRestrictionBadgeView $variant={variant} borderRadius={borderRadius}>

        <AgeRestrictionText $variant={variant}>{ageRestrictedText}</AgeRestrictionText>
      </AgeRestrictionBadgeView>
    </BadgeContainer>
  );
};

export default memo(AgeRestrictionBadge);
